import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPaymentHistory,
  fetchPaymentDetails,
} from "./paymentHistoryThunks";

const initialState = {
  history: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    pages: 1,
  },

  selectedPayment: null,

  loadingHistory: false,
  loadingDetails: false,

  error: null,
};

const paymentHistorySlice = createSlice({
  name: "paymentHistory",
  initialState,
  reducers: {
    clearPaymentDetails(state) {
      state.selectedPayment = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // -----------------------
      // PAYMENT HISTORY
      // -----------------------
      .addCase(fetchPaymentHistory.pending, (state) => {
        state.loadingHistory = true;
        state.error = null;
      })
      .addCase(fetchPaymentHistory.fulfilled, (state, action) => {
        state.loadingHistory = false;
        state.history = action.payload.payments;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchPaymentHistory.rejected, (state, action) => {
        state.loadingHistory = false;
        state.error = action.payload;
      })

      // -----------------------
      // PAYMENT DETAILS
      // -----------------------
      .addCase(fetchPaymentDetails.pending, (state) => {
        state.loadingDetails = true;
        state.error = null;
      })
      .addCase(fetchPaymentDetails.fulfilled, (state, action) => {
        state.loadingDetails = false;
        state.selectedPayment = action.payload;
      })
      .addCase(fetchPaymentDetails.rejected, (state, action) => {
        state.loadingDetails = false;
        state.error = action.payload;
      });
  },
});

export const { clearPaymentDetails } = paymentHistorySlice.actions;
export default paymentHistorySlice.reducer;
